export default __webpack_public_path__ + "static/media/Signup.e1ff6712.png";